var _rect, _path, _path2, _line, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EBEEF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5403 21.4195C30.5338 21.9479 30.9965 22.2428 31.345 22.4181C31.7031 22.5979 31.8234 22.7133 31.822 22.8742C31.8193 23.1203 31.5364 23.229 31.2716 23.2332C30.8096 23.2406 30.541 23.1044 30.3274 23.0015L30.161 23.8053C30.3753 23.9072 30.772 23.9961 31.1834 24C32.1491 24 32.7808 23.5079 32.7843 22.745C32.788 21.7768 31.4868 21.7232 31.4957 21.2904C31.4988 21.1592 31.6201 21.0192 31.8859 20.9836C32.0175 20.9656 32.3807 20.9518 32.7925 21.1476L32.9541 20.3698C32.7327 20.2866 32.448 20.2069 32.0937 20.2069C31.1848 20.2069 30.5455 20.7057 30.5403 21.4195ZM34.5071 20.2739C34.3308 20.2739 34.1822 20.3801 34.1159 20.543L32.7364 23.9429H33.7014L33.8934 23.3951H35.0726L35.184 23.9429H36.0345L35.2923 20.2739H34.5071ZM34.6421 21.265L34.9206 22.6428H34.1579L34.6421 21.265ZM29.3703 20.2739L28.6097 23.9428H29.5292L30.2895 20.2738H29.3703V20.2739ZM28.01 20.2738L27.0529 22.7711L26.6657 20.6478C26.6203 20.4108 26.4409 20.2739 26.2417 20.2739H24.6771L24.6552 20.3804C24.9764 20.4524 25.3413 20.5684 25.5624 20.6926C25.6978 20.7684 25.7363 20.8347 25.7808 21.015L26.5141 23.9429H27.4858L28.9756 20.2739H28.01",
    fill: "url(#paint0_linear_3928_42164)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2992 14.6895L19.0845 19.0542L15.2992 23.3046H12.8206L16.6443 19.2067L12.8206 14.6895H10.5725L14.0887 19.0542L10.3419 23.3046H6.01862C5.67276 23.3427 4.98488 23.2017 5.00025 22.3325C5.01563 21.4634 5.00666 17.4849 5.00025 15.6043C5.00666 15.2994 5.2193 14.6895 6.01862 14.6895C6.81795 14.6895 8.15784 14.6895 8.72787 14.6895",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.3964,
    y1: 14.5,
    x2: 22.3964,
    y2: 23.5,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5732,
    cy: 16.0474,
    r: 2.04741,
    fill: "#EF9637"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 29.1163,
    cy: 16.0474,
    r: 2.04741,
    fill: "#D62F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3928_42164",
    x1: 29.8867,
    y1: 24.0761,
    x2: 30.0001,
    y2: 20.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.84fe1220f723f07c213be79e956045ae.svg";
export { ForwardRef as ReactComponent };